<template>
  <div>
    <template v-for="(item, index) in data">
      <el-submenu :key="index" v-if="item.children && item.children.length>0" :index="item.id + ''" :id="'submenu-' + item.id" :class="selectSubMenu != '' && selectSubMenu == ('submenu-' + item.id) ? 'submenu-is-active' : ''">
        <template slot="title">
          <div @click.stop="onSelectSubMenu(item)">
            <span class="menu-slit"></span>
            <img class="menu-icon" :src="item.img" v-if="item.img"/>
            <span class="menu-text">{{ item.title }}</span>
          </div>
        </template>
        <Menu :data="item.children" />
        <div class="menu-item-divider"></div>
      </el-submenu>
      <el-menu-item @click="onSelect(item)" :key="index" :index="item.path" :disabled="!item.path" v-else  :class="selectSubMenu != '' && selectSubMenu == ('submenu-' + item.id) ? 'submenu-is-active' : ''">
        <span class="menu-slit"></span>
        <img class="menu-icon" :src="item.img" v-if="item.img"/>
        <span slot="title" class="menu-text">{{ item.title }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: {
    data: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
  },
  data(){
    return {
      selectSubMenu: '',
    }
  },
  methods: {
    fetchSelectMenuIndex(item) {
      if(item.id >= 3 && item.id <= 7) {
        return item.id - 3;
      }
      if(item.id == 12) {
        return 5;
      }
      return -1;
    },
    onSelect(item) {
      // console.log('onSelect', item, item.id, item.path, new Date())
      this.selectSubMenu = '';
      this.$router.push({path: item.path, query:{'st':new Date().getTime()}});
      let menuItemActiveElems = document.querySelectorAll('.el-menu-item.is-active')
      if(menuItemActiveElems.length == 0) {
        let menuIndex = this.fetchSelectMenuIndex(item)
        let menuItemActiveElems = document.querySelectorAll('.el-menu-item')
        if (menuIndex >= 0 && menuIndex < menuItemActiveElems.length) {
          menuItemActiveElems[menuIndex].setAttribute('class', 'el-menu-item is-active')
        }
      }
    },
    onSelectSubMenu(item) {
      // console.log('onSelectSubMenu', item, item.id, item.path, new Date())
      this.selectSubMenu = 'submenu-' + item.id;
      this.$router.push({path: item.path, query:{'st':new Date().getTime()}});
    },
    resetSelectSubMenu(){
      this.selectSubMenu = '';
    },
    setDefaultSelected(id){
      this.selectSubMenu = id;
      let menuItemActiveElems = document.querySelectorAll('.el-menu-item.is-active')
      if(menuItemActiveElems.length > 0) {
        menuItemActiveElems [0].setAttribute('class', 'el-menu-item')
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-slit{
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background-color: #35c2be;
}
.menu-icon{
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
.el-menu-item.is-active{
  background-color: #E6EDF5 !important;

  .menu-slit{
    display: inline-block;
  }
}
.el-submenu .el-menu-item{
  padding-left: 70px !important;
}
::v-deep i.el-submenu__icon-arrow {
  display: none;
}
.menu-item-divider{
  background-color: #F0F2F5;
  height: 1px;
  margin-left: 20px;
}
</style>
<style scoped>
@import "./MenuTree.scss";
</style>
